
<template>
  <div>
    <v-row
      align="center"
      class="my-2"
    >
      <v-col>
        <stat-card
          :loading="loading"
          :title="$t('load_zones.underload')"
          :value="'< ' + latestTeamStats.WL_Underload"
          :visual="false"
        />
      </v-col>
      <v-col>
        <stat-card
          :loading="loading"
          :title="$t('load_zones.taper')"
          :value="latestTeamStats.WL_Underload + ' - ' + latestTeamStats.WL_Taper"
          :visual="false"
        />
      </v-col>
      <v-col>
        <stat-card
          :loading="loading"
          :title="$t('card_title.ordinary')"
          :value="latestTeamStats.WL_Taper + ' - ' + latestTeamStats.WL_Ordinary"
          :visual="false"
        />
      </v-col><v-col>
        <stat-card
          :loading="loading"
          :title="$t('load_zones.development')"
          :value="latestTeamStats.WL_Ordinary + ' - ' + latestTeamStats.WL_Development"
          :visual="false"
        />
      </v-col>
      <v-col>
        <stat-card
          :loading="loading"
          :title="$t('card_title.overload')"
          :value="'> ' + latestTeamStats.WL_Development"
          :visual="false"
        />
      </v-col>
    </v-row>
    <v-card class="pa-0">
      <v-data-table
        :headers="tableHeaders"
        :loading="loading"
        :items="players"
        hide-default-footer
        dense
        disable-pagination
        sort-by="last_name"
      >
        <!--<editor-fold desc="ITEM SLOT">-->
        <template v-slot:item="{ item }">
          <tr style="height: 80px">
            <td class="text-no-wrap">
              {{ item.last_name }}, {{ item.first_name }}
            </td>
            <td
              v-for="tableHeader in tableHeaders.slice(1)"
              :key="tableHeader.id"
            >
              <w-l-progress-value
                :value="getValue(item, tableHeader.value)"
                :max="20/13 * getValue(item, 'latest_stats.WL_Development')"
                :color="getColorFromValue(getValue(item, tableHeader.value), 1.2 * getValue(item, 'latest_stats.WL_Development'))"
                :stats="item.latest_stats"
              >
                {{ getValue(item, tableHeader.value) }}
              </w-l-progress-value>
            </td>
          </tr>
        </template>
        <template slot="loading">
          <div
            class="pa-5 d-flex justify-center align-center"
            :style="'min-height: ' + (players.length * 49)+'px'"
          >
            <v-progress-circular
              indeterminate
              size="48"
              width="4"
              color="grey lighten-2"
            />
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import StatCard from '@/components/StatCard.vue'
import { getColorForValue } from '@/utils/helpers'
import WLProgressValue from '@/components/training-load/WLProgressValue.vue'
import i18n from '@/plugins/i18n'

export default {
  name: 'TrainingLoadPlanification',
  components: { WLProgressValue, StatCard },
  props: {
    latestTeamStats: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    players: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    tableHeaders: [
      { value: 'last_name', text: i18n.t('table_headers.name'), align: 'start', sortable: true, width: '15%' },
      { value: 'latest_stats.WL', text: i18n.t('table_headers.planning_load.zones'), sortable: true }
    ]
  }),
  methods: {
    getColorFromValue(value, max, reverse = false) {
      return getColorForValue(value, max, reverse)
    },
    getValue(player, variable) {
      return player.latest_stats[variable.split('.')[1]]
    }
  }
}
</script>
